import React from 'react';
import Button from 'common/components/Button';
import { ButtonSchema, ButtonSize } from 'common/components/Button/constants';
import styles from './BadgeButton.module.scss';

interface IBadgeButtonProps {
  label: string;
  count: number;
  onClick: () => void;
  disabled?: boolean;
  schema?: ButtonSchema;
  size?: ButtonSize;
  className?: string;
}

const BadgeButton = ({
  label,
  count,
  onClick,
  disabled = false,
  schema = ButtonSchema.primary,
  size = ButtonSize.standard,
  className,
}: IBadgeButtonProps) => (
  <div className={styles.wrapper}>
    <Button
      schema={schema}
      size={size}
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      {label}
    </Button>
    <span className={styles.badge}>{count}</span>
  </div>
);

export default BadgeButton;
